import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TraderNavTabs = ({ accountId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const tabs = [
    { label: 'Dashboard', path: '/trader', exact: true },
    { label: ' Performance', path: '/trader/performance' },
    { label: ' Analytics', path: '/analytics' },
  ];

  const isActive = (tab) => {
    if (tab.exact) {
      return currentPath === tab.path;
    }
    return currentPath.startsWith(tab.path);
  };

  const handleClick = (tab) => {
    const url = accountId 
      ? `${tab.path}?account_id=${accountId}` 
      : tab.path;
    navigate(url);
  };

  return (
    <div style={{
      display: 'flex',
      gap: 8,
      marginBottom: 24,
      borderBottom: '1px solid #333',
      paddingBottom: 0
    }}>
      {tabs.map((tab) => (
        <button
          key={tab.path}
          onClick={() => handleClick(tab)}
          style={{
            padding: '10px 20px',
            background: 'transparent',
            border: 'none',
            borderBottom: isActive(tab) ? '2px solid #3b82f6' : '2px solid transparent',
            color: isActive(tab) ? '#3b82f6' : '#6b7280',
            fontWeight: isActive(tab) ? 600 : 400,
            fontSize: 14,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            marginBottom: -1,
            whiteSpace: 'nowrap'
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TraderNavTabs;
